import React, { useState } from "react";
import { Icon, Popup } from "semantic-ui-react";
import { Integration } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { useLanguage } from "../../../../contexts";
import "./PeerAppButton.scss";

const integrationController = new Integration();

// Nombre corto de cada app para el botón del menú.
const SHORT_NAMES = { sh: "SH", sustentable: "Ambiental" };

// Botón del menú lateral para abrir la otra app Sustemia ya logueado. Solo
// aparece si la empresa la tiene contratada y el usuario tiene acceso.
export function PeerAppButton({ collapsed }) {
  const { user, accessToken } = useAuth();
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const [busy, setBusy] = useState(false);

  const peerApp = user?.peerApp;
  if (!peerApp?.enabled) return null;

  const label = `${t("go_to_app")} ${SHORT_NAMES[peerApp.key] || peerApp.name}`;

  // La pestaña se abre en el mismo clic (si no, el navegador la bloquea como
  // pop-up) y se le carga la URL cuando llega el token de traspaso.
  const goToPeerApp = async () => {
    setBusy(true);
    const tab = window.open("", "_blank");
    try {
      const { url } = await integrationController.handoff(accessToken);
      if (tab) tab.location.href = url;
      else window.location.assign(url);
    } catch (error) {
      if (tab) tab.close();
      window.alert(error.msg || t("server_connection_error"));
    } finally {
      setBusy(false);
    }
  };

  const button = (
    <button
      type="button"
      className={`peer-app-btn peer-app-btn--${peerApp.key}${collapsed ? " peer-app-btn--collapsed" : ""}`}
      onClick={goToPeerApp}
      disabled={busy}
      aria-label={label}
    >
      <Icon name="external alternate" />
      {!collapsed && <span>{label}</span>}
    </button>
  );

  if (!collapsed) return button;
  return <Popup content={label} position="right center" trigger={button} inverted size="small" />;
}
